/* eslint-env browser */

(function (window) {
    'use strict';

    function escapeHtml(text) {
        var div = document.createElement('div');
        div.textContent = text == null ? '' : String(text);
        return div.innerHTML;
    }

    function ensureLightbox() {
        if (document.getElementById('siwa-landing-lightbox')) {
            return;
        }
        document.body.insertAdjacentHTML(
            'beforeend',
            '<div class="siwa-landing-lightbox" id="siwa-landing-lightbox" hidden>' +
            '<div class="siwa-landing-lightbox__backdrop" data-siwa-landing-lightbox-close></div>' +
            '<div class="siwa-landing-lightbox__panel" role="dialog" aria-labelledby="siwa-landing-lightbox-title" aria-modal="true">' +
            '<button type="button" class="siwa-landing-lightbox__close" data-siwa-landing-lightbox-close aria-label="Chiudi">&times;</button>' +
            '<h3 id="siwa-landing-lightbox-title" class="siwa-landing-lightbox__title"></h3>' +
            '<div class="siwa-landing-lightbox__body" id="siwa-landing-lightbox-body"></div>' +
            '</div>' +
            '</div>'
        );
    }

    function closeLightbox() {
        var modal = document.getElementById('siwa-landing-lightbox');
        if (!modal) {
            return;
        }
        modal.hidden = true;
        document.body.classList.remove('siwa-landing-lightbox-open');
        var bodyEl = document.getElementById('siwa-landing-lightbox-body');
        if (bodyEl) {
            bodyEl.innerHTML = '';
        }
    }

    function openLightbox(src, caption) {
        var modal = document.getElementById('siwa-landing-lightbox');
        var titleEl = document.getElementById('siwa-landing-lightbox-title');
        var bodyEl = document.getElementById('siwa-landing-lightbox-body');
        if (!modal || !bodyEl || !src) {
            return;
        }

        if (titleEl) {
            titleEl.textContent = caption || '';
            titleEl.hidden = !caption;
        }

        bodyEl.innerHTML =
            '<img class="siwa-landing-lightbox__image" src="' + escapeHtml(src) + '" alt="' + escapeHtml(caption || 'Screenshot Siwa') + '" />';

        modal.hidden = false;
        document.body.classList.add('siwa-landing-lightbox-open');
    }

    function bindLightboxEvents() {
        if (document.body.getAttribute('data-siwa-landing-lightbox-bound') === '1') {
            return;
        }
        document.body.setAttribute('data-siwa-landing-lightbox-bound', '1');

        document.addEventListener('click', function (event) {
            if (event.target.closest('[data-siwa-landing-lightbox-close]')) {
                closeLightbox();
                return;
            }

            var trigger = event.target.closest('[data-siwa-landing-shot]');
            if (!trigger) {
                return;
            }

            var img = trigger.querySelector('img');
            if (!img || !img.src) {
                return;
            }

            event.preventDefault();
            openLightbox(
                img.currentSrc || img.src,
                trigger.getAttribute('data-shot-caption') || img.getAttribute('alt') || ''
            );
        });

        document.addEventListener('keydown', function (event) {
            if (event.key === 'Escape') {
                closeLightbox();
            }
        });
    }

    function init() {
        if (!document.querySelector('.siwa-landing-page')) {
            return;
        }
        ensureLightbox();
        bindLightboxEvents();
    }

    window.SiwaLanding = {
        init: init
    };
})(window);
